
const ChecklistItemDefault = {
        didPass: false,
        comment: "",
        approvalDate: new Date()
};

export default ChecklistItemDefault;